<template>
  <div>
    <modal
      name="templateUpdate"
      title="Update Template"
      class="custom-modal"
      height="auto"
      width="80%"
      :adaptive="true"
    >
      <template v-slot:content>
        <div class="add-template">
          <div class="flex align-center space-between">
            <Input
              class="template-title"
              type="text"
              placeholder="Template title"
              v-model="title"
            />
            <div class="flex align-center">
              <Select
                placeholder="Service Head"
                class="mr-2 template-title"
                :value="lookupName"
                :options="serviceHeadList"
                :input="handleServices"
                :clearable="false"
              />
              <Button
                title="Update"
                className="button--primary"
                :onClick="handleUpdate"
                :loader="loading"
              />
            </div>
          </div>
          <TemplateEditor ref="updateTemplate" height="400" :content="report" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import TemplateEditor from "@/components/TemplateEditor";
import Button from "@/components/Button";
import Input from "@/components/Input";
import Modal from "@/components/Modal";
import Select from "@/components/Select";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["report"],
  components: {
    TemplateEditor,
    Select,
    Button,
    Input,
    Modal
  },
  data() {
    return {
      title: "",
      lookupId: "",
      lookupName: ""
    };
  },
  methods: {
    ...mapActions("reports", ["updateTemplate"]),
    handleUpdate() {
      const report = this.$refs.updateTemplate.editor.getContents();
      const payload = {
        name: this.title,
        report: report,
        lookupId: this.lookupId
      };
      this.updateTemplate({
        id: this.templateDetails.id,
        payload: payload
      }).then(() => {
        this.lookup = {};
        this.$modal.hide("templateUpdate");
      });
    },
    handleServices(val) {
      this.lookupId = val.id;
      this.lookupName = val.name;
    }
  },
  computed: {
    ...mapGetters({
      listDoctors: "doctors/listDoctors",
      templateDetails: "reports/templateDetails",
      loading: "loading"
    }),
    serviceHeadList() {
      const items = this.listDoctors || [];
      return items.map(item => ({
        id: item.id,
        name: item.name
      }));
    }
  },
  watch: {
    templateDetails(val) {
      this.title = val.name;
      this.lookupName = val && val.lookup && val.lookup.name;
    }
  }
};
</script>

<style></style>
